import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { checkFieldsValidity } from '../../shared/index';
import { ManageBidInstructionService } from '../manage-bid-instruction.service';
import { BidInstruction, BidInstructionSearchParams } from '../models';

@Component({
  selector: 'app-list-bid-instruction',
  templateUrl: './list-bid-instruction.component.html',
  styleUrls: ['./list-bid-instruction.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmationService, ManageBidInstructionService]
})

export class ListBidInstructionComponent implements OnInit {

  @Output() doeditBidInstructionEvent = new EventEmitter<boolean>();
  @Output() selectedBidInstruction = new EventEmitter<{}>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();

  // Take reference for the drop downs
  @ViewChild('multiSelectState') multiSelectState: MultiSelect;
  @ViewChild('multiSelectTrustee') multiSelectTrustee: MultiSelect;
  @ViewChild('dt') table: Table;

  pageNo: number = 1;
  defaultLabel: string;
  bidInstructions: BidInstruction[];
  bidParms: BidInstructionSearchParams;
  loading = false;
  propertyState: any[];
  trustee: any[];
  selectedPropertyState: any[];
  listBidInstructionForm: FormGroup;
  selectedTrustee: any[];
  cols: any[];
  records: number;
  loadingSearchResult: boolean;
  formSubmitted: boolean = false;
  default: string = 'Select One';
  disableForm: boolean;
  processing: boolean;
  stateCodeList: string = '';
  loadingStates: boolean;
  showTable: boolean;
  excelUrl: any;
  confirmDialog: boolean;
  deleteBidId: any;
  pages: number;


  constructor(private manageBidInstructionService: ManageBidInstructionService) {

  }

  ngOnInit() {
    this.listBidInstructionForm = new FormGroup({
      propertyState: new FormControl('', null),
      trustee: new FormControl('', null)
    }, checkFieldsValidity(Validators.required));

    this.multiSelectTrustee.resetFilterOnHide = false;
    this.multiSelectState.resetFilterOnHide = false;
    this.cols = [
      { field: 'BidMatrixId', header: 'Bid ID', showInHeader: true },
      { field: 'LenderId', header: 'Changed Date', showInHeader: false },
      { field: 'StateCode', header: 'Property State', showInHeader: true },
      { field: 'State', header: 'State', showInHeader: false },
      { field: 'TrusteeId', header: 'Status', showInHeader: false },
      { field: 'TrusteeName', header: 'Trustee Name', showInHeader: true },
      { field: 'BidInstructionDocsIncluded', header: 'Bid Instruction Docs Included?', showInHeader: true },
      { field: 'Action', header: 'Action', showInHeader: true },
      { field: 'COSAltisourceCopyIncluded', header: 'COS Altisource Copy Included', showInHeader: false },
      { field: 'COSBuyerCopyIncluded', header: 'COS Buyer Copy Included', showInHeader: false },
      { field: 'AltisourceBidSheetIncluded', header: 'Altisource Bid Sheet Included', showInHeader: false },
      { field: 'BidInstructionFilePath', header: 'Bid Instruction file Path', showInHeader: false },
      { field: 'BidInstructionFileName', header: 'Bid Instruction file Name', showInHeader: false },
      { field: 'BidInstructionFileId', header: 'Bid Instruction File ID', showInHeader: false },
      { field: 'IsActive', header: 'Is Active', showInHeader: false },
      { field: 'BiddingFileUploadedDate', header: 'File Upload Date', showInHeader: false }
    ];

    let stateCode = localStorage.getItem('StateCode');
    let trusteeId = localStorage.getItem('TrusteeId');
    this.manageBidInstructionService.getStatesForMangeScreen().subscribe(data => {
      this.propertyState = data.filter(x => x.value != 'ALL');
      if (stateCode && stateCode.length > 0) {
        let stateArray = [];
        this.selectedPropertyState = [];
        stateCode.split(",").map((item) => {
          stateArray.push(item.trim())
        });
        this.selectedPropertyState = this.propertyState
          .filter(a => stateArray.indexOf(a.value.toString()) !== -1)
          .map(a => a.value);
      }
    });
    this.manageBidInstructionService.getAvailableTrusteesForMangeScreen().subscribe(response => {
      this.trustee = response;
      if (trusteeId && trusteeId.length > 0) {
        this.selectedTrustee = [];
        let trusteeArray = [];
        trusteeId.split(",").map((item) => {
          trusteeArray.push(item.trim())
        });
        this.selectedTrustee = this.trustee
          .filter(a => trusteeArray.indexOf(a.value.toString()) !== -1)
          .map(a => a.value);
      }
    });
    if ((stateCode && stateCode.length > 0) || (trusteeId && trusteeId.length > 0)) {
      this.formSubmitted = true;
      this.loadingSearchResult = true;
      this.bidParms = <BidInstructionSearchParams>{};
      this.bidParms.StateCode = (stateCode && stateCode.length > 0) ? stateCode.split(',') : [];
      this.bidParms.TrusteeId = (trusteeId && trusteeId.length > 0) ? trusteeId.split(',') : [];
      this.getbidInstructionMatrixData();
    }
  }

  isPaginatorVisible(): boolean {
    return (this.bidInstructions && this.bidInstructions.length > 0) ? true : false;
  }

  resetForm() {
    this.listBidInstructionForm.reset();
    this.bidInstructions = [];
    this.formSubmitted = false;
    this.multiSelectTrustee.resetFilterOnHide = true;
    this.multiSelectState.resetFilterOnHide = true;
    localStorage.clear();
  }

  onSubmitListBidInstructionForm(): void {
    this.formSubmitted = true;
    this.setBidinstructionsParams();
    this.getbidInstructionMatrixData()
  }

  setBidinstructionsParams(): void {
    this.pages = Math.ceil(this.table.totalRecords / this.table.rows);
    this.bidParms = <BidInstructionSearchParams>{};
    this.bidParms.StateCode = this.listBidInstructionForm.value.propertyState == undefined ? [] : this.listBidInstructionForm.value.propertyState;
    this.bidParms.TrusteeId = this.listBidInstructionForm.value.trustee == undefined ? [] : this.listBidInstructionForm.value.trustee;
    localStorage.setItem("StateCode", this.bidParms.StateCode.join(','));
    localStorage.setItem("TrusteeId", this.bidParms.TrusteeId.join(','));
  }

  setCurrentPage() {
    this.pages = Math.ceil(this.table.totalRecords / this.table.rows);
    if (this.pageNo <= this.pages) {
      this.table.first = (Number(this.pageNo) - 1) * 10;
      const pageCount = Math.ceil(this.table.totalRecords / this.table.rows);
      this.table.onPageChange({
        pageCount,
        page: Number(this.pageNo),
        first: (Number(this.pageNo) - 1) * this.table.rows,
        rows: this.table.rows
      });
    }
  }

  validate(event) {
    return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57
  }

  getbidInstructionMatrixData(): void {
    this.table.first = 0;
    this.loadingSearchResult = true;
    this.manageBidInstructionService.getBidInstruction(null, this.bidParms).subscribe(bidInstructionData => {
      this.loadingSearchResult = false;
      this.bidInstructions = bidInstructionData.data;
      this.records = bidInstructionData.meta.pagination.TotalRecords;
      this.excelUrl = (<any>_GlobalNS).api.bidInstruction.buildExcel + '&' + 'states' + '=' + this.bidParms.StateCode.join(',') + '&' + 'trustees' + '=' + this.bidParms.TrusteeId.join(',')
      this.showTable = true;
    });
  }


  showEditBidInstruction(data: BidInstruction): any {
    this.doeditBidInstructionEvent.emit(true);
    this.selectedBidInstruction.emit(data);
    this.setBreadCrumbs.emit([{ label: 'Mange Bid Instruction Matrix' }, { label: 'Edit Bid Instruction' }]);
  }

  downloadFile(bidMatrixId: number) {
    this.manageBidInstructionService.downloadBidInstructionFile(bidMatrixId);
  }

  deleteBidmatrix(bidMatrixId: number) {
    let bidMatrixID = bidMatrixId;
    this.manageBidInstructionService.delete(bidMatrixID).subscribe(response => {
      if (response.data.length > 0) {
        this.onSubmitListBidInstructionForm();
      }
    });
  }

}